import React from 'react';

export default function Tooltip({ children, content, className = '' }) {
  return (
    <span className={`group relative cursor-pointer ${className}`.trim()}>
      {children}
      <span className="pointer-events-none absolute z-50 left-1/2 -translate-x-1/2 mt-2 w-max min-w-[120px] max-w-xs px-3 py-2 rounded-lg bg-gray-900 text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg border border-cyan-400/30" style={{top: '100%'}}>
        {content}
      </span>
    </span>
  );
}
